const Getters = {
  getRefundListFromState: (state) => {
    return state.refundList
  }
}

export default Getters
